"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACChip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACChip = function (_a) {
    var node = _a.node, executeEventHandlers = _a.executeEventHandlers;
    var _b = node.label, label = _b === void 0 ? '' : _b, _c = node.colors, colors = _c === void 0 ? {} : _c, _d = node.icons, icons = _d === void 0 ? {} : _d, _e = node.className, className = _e === void 0 ? '' : _e;
    var _f = node.color, color = _f === void 0 ? 'default' : _f, _g = node.icon, icon = _g === void 0 ? '' : _g, _h = node.iconClassName, iconClassName = _h === void 0 ? '' : _h;
    var modifiedLabel = label === null || label === void 0 ? void 0 : label.toLowerCase().replace(/\s+/g, '-');
    color = (colors === null || colors === void 0 ? void 0 : colors[modifiedLabel]) || color;
    var iconData = (icons === null || icons === void 0 ? void 0 : icons[modifiedLabel]) || {
        icon: '',
        className: '',
    };
    icon = (iconData === null || iconData === void 0 ? void 0 : iconData.icon) || icon;
    iconClassName = (iconData === null || iconData === void 0 ? void 0 : iconData.className) || iconClassName;
    return ((0, jsx_runtime_1.jsxs)("button", { className: "apx-ui_chip ".concat(color, " ").concat(className), onClick: function (e) {
            e.stopPropagation();
            executeEventHandlers(node.handlers || [], event);
        }, children: [icon && ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(icon, " ").concat(iconClassName || 'ac-dynamic-size size-[12px]') })), (0, jsx_runtime_1.jsx)("span", { className: "capitalize", children: label })] }));
};
exports.ACChip = ACChip;
